module.exports = __webpack_public_path__ + "static/media/file-with-search.d468c1af.svg";